import { render } from "./BadgeV2.vue?vue&type=template&id=7e28fe89&scoped=true"
import script from "./BadgeV2.vue?vue&type=script&lang=js"
export * from "./BadgeV2.vue?vue&type=script&lang=js"

import "./BadgeV2.vue?vue&type=style&index=0&id=7e28fe89&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e28fe89"]])

export default __exports__